import React, { useState } from 'react';
import './App.css';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { Reviews } from './components/Reviews';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { RegistrationModal } from './components/RegistrationModal';
import { Toaster } from './components/ui/sonner';

function App() {
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);

  return (
    <div className="App">
      <Navbar onRegisterClick={() => setIsRegistrationOpen(true)} />
      <Hero onRegisterClick={() => setIsRegistrationOpen(true)} />
      <Services />
      <About />
      <Reviews />
      <Contact />
      <Footer />
      <RegistrationModal 
        isOpen={isRegistrationOpen} 
        onClose={() => setIsRegistrationOpen(false)} 
      />
      <Toaster />
    </div>
  );
}

export default App;
